export default [
  {
    title: '<i>01</i>Stable global<br class="hidden-md-down" />leased lines',
    copy: 'Line integration with the entire northern hemisphere overage',
    exp:
      'The Global Region service provides stable service by minimizing the influence from other communications, because it uses the global leased lines that connect key locations around the world unlike regular internet lines.<br />We have secured rack spaces in key network locations where global operators gather and linked them with the lines made redundant 3-4 times over, integrating the lines to cover the entire northern hemisphere.<br />Please note that the connection speed between locations may vary depending on the distance.',
  },
  {
    title: '<i>02</i>Reliable security',
    copy: '24 x 365 protection based on IDS',
    exp:
      'All Global Regions provide the IDS-based Basic Security service that protects customer data 24 hours a day, 365 days a year, as well as the high-level security services centering around the Security Monitoring service.',
    subExp01: 'IDS: Intrusion Detection System',
    subExp02: 'Security Monitoring service: available in Korea, Singapore, Japan, United States (West), Germany Regions only, to be expanded to all Regions in the future',
  },
  {
    title: '<i>03</i>Excellent system<br class="hidden-md-down" /> availability',
    copy: 'Availability secured through redundancy',
    exp:
      "System availability is ensured through High Availability (HA) configurations on switches, security equipment, and servers. All Global Region configurations are made redundant to enhance the service's stability and availability.<br />In particular, the key global locations are connected with the leased ISP lines to provide fail-free services at all times.",
  },
  {
    title: '<i>04</i>Web-based console<br /> environment provides<br />convenience',
    copy: 'The same web-based console environment as before',
    exp:
      'The Global Region service maintains its web-based console environment that has the same look and features as the existing console.<br />Users can choose a Region of their choice to use the service to suit their needs.',
  },
  {
    title: '<i>05</i>Efficient Cost<br /> Management',
    copy: 'The same pricing policy applied locally and internationally',
    exp:
      'Costs incurred are relatively high in Global Regions compared to domestic services, but we keep the same pricing policy providing the cost reduction effect for our service users.<br />In particular, we provide the global leased lines we invested in large scale for a long time at a low price<br />to make the inter-Region server images and snapshot duplications through the leased line available for free.',
  },
  {
    title: '<i>06</i>Global Region<br class="hidden-md-down" /> rebuilding',
    copy: 'The same services available locally and internationally',
    exp:
      'We are continuously updating our services to help you use the domestic services also in Global Regions without feeling any inconvenience.<br />For this, we are working on revamping our infrastructure and network in each Region. As of 2020, the same services as in the Korea Region environment are available in the Singapore, Japan, U.S. (West), and Germany Regions.',
  },
];
